import { useTranslation } from 'react-i18next';
import { useSendContactMutation } from 'services/contact';
import { toast } from 'react-toastify';
import { Button } from 'ui/atoms/buttons';
import { Textarea } from 'ui/atoms/textarea';
import { Label } from 'ui/atoms/labels';
import { FormField } from 'ui/molecules/FormFields';
import { Alert } from 'ui/molecules/Alerts';
import { Form } from 'ui/layout/Forms';
import { Card } from 'ui/layout/Cards';


import styled from 'styled-components';
import { useEffect } from 'react';


const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 300px;
  margin: 0 auto;
`;


export const ContactForm = ({ onClose }: { onClose: () => void }) => {
  const [sendContact, { isLoading, isSuccess, isError }] = useSendContactMutation();
  const { t } = useTranslation();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);
    const data = {
      name: formData.get('name') as string,
      email: formData.get('email') as string,
      message: formData.get('message') as string,
    };
    await sendContact(data);
    form.reset();
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(t('contactForm:successMessage') as string);
      onClose();
    } else if (isError) {
      toast.error(t('contactForm:errorMessage') as string);
    }
  }, [isSuccess, isError, t]);

  return (
    <Card>
      <Form onSubmit={handleSubmit}>
        <FormField label={t('contactForm:nameLabel') as string} name="name" type="text" required />
        <FormField label={t('contactForm:emailLabel') as string} name="email" type="email" required />
        <Label htmlFor="message">{t('contactForm:messageLabel')}</Label>
        <Textarea id="message" name="message" rows={5} required />
        <Button type="submit" disabled={isLoading}>
          {isLoading ? t('contactForm:sendingButton') : t('contactForm:sendButton')}
        </Button>
      </Form>
    </Card>
  );
}

